import * as api from '@modules/appeals/api/workCase';
import {
    createRequestTypes,
    START,
    SUCCESS,
    ERROR,
  } from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPEALS';

export const FETCH_APPEAL_PANELS = createRequestTypes(
  `${prefix}/FETCH_APPEAL_PANELS`,
);

export const fetchAppealPanels = makeApiActionCreatorV3(
  api.fetchAppealPanels,
  FETCH_APPEAL_PANELS[START],
  FETCH_APPEAL_PANELS[SUCCESS],
  FETCH_APPEAL_PANELS[ERROR],
);

export const FETCH_DIRECT_ASSIGNMENTS = createRequestTypes(
  `${prefix}/FETCH_DIRECT_ASSIGNMENTS`,
);

export const fetchAppealPanelDirectAssignments = makeApiActionCreatorV3(
  api.fetchAppealPanelDirectAssignments,
  FETCH_DIRECT_ASSIGNMENTS[START],
  FETCH_DIRECT_ASSIGNMENTS[SUCCESS],
  FETCH_DIRECT_ASSIGNMENTS[ERROR],
);

export const GET_NEXT_CASE_FOR_PANEL = createRequestTypes(
  `${prefix}/GET_NEXT_CASE_FOR_PANEL`,
);

export const getNextCaseForPanel = makeApiActionCreatorV3(
  api.getNextCaseForPanel,
  GET_NEXT_CASE_FOR_PANEL[START],
  GET_NEXT_CASE_FOR_PANEL[SUCCESS],
  GET_NEXT_CASE_FOR_PANEL[ERROR],
);

export const TAKE_APPEAL = createRequestTypes(
  `${prefix}/TAKE_APPEAL`,
);

export const takeappeal = makeApiActionCreatorV3(
  api.takeappeal,
  TAKE_APPEAL[START],
  TAKE_APPEAL[SUCCESS],
  TAKE_APPEAL[ERROR],
);

export const RETURN_CURRENT_APPEAL = createRequestTypes(
  `${prefix}/RETURN_CURRENT_APPEAL`,
);

export const returnCurrentAppeal = makeApiActionCreatorV3(
  api.returnCurrentAppeal,
  RETURN_CURRENT_APPEAL[START],
  RETURN_CURRENT_APPEAL[SUCCESS],
  RETURN_CURRENT_APPEAL[ERROR],
);

export const GET_CURRENT_APPEAL_FOR_PANEL = createRequestTypes(
  `${prefix}/GET_CURRENT_APPEAL_FOR_PANEL`,
);

export const getCurrentAppealForPanel = makeApiActionCreatorV3(
  api.getCurrentAppealForPanel,
  GET_CURRENT_APPEAL_FOR_PANEL[START],
  GET_CURRENT_APPEAL_FOR_PANEL[SUCCESS],
  GET_CURRENT_APPEAL_FOR_PANEL[ERROR],
);

export const GET_DAILY_STATISTICS_FOR_PANEL = createRequestTypes(
  `${prefix}/GET_DAILY_STATISTICS_FOR_PANEL`,
);

export const getDailyStatisticsForPanel = makeApiActionCreatorV3(
  api.getDailyStatisticsForPanel,
  GET_DAILY_STATISTICS_FOR_PANEL[START],
  GET_DAILY_STATISTICS_FOR_PANEL[SUCCESS],
  GET_DAILY_STATISTICS_FOR_PANEL[ERROR],
);

export const START_MEETING = createRequestTypes(
  `${prefix}/START_MEETING`,
);

export const startMeeting = makeApiActionCreatorV3(
  api.startMeeting,
  START_MEETING[START],
  START_MEETING[SUCCESS],
  START_MEETING[ERROR],
);

export const DIRECT_ASSIGNMENT_TAKE_APPEAL = createRequestTypes(
  `${prefix}/DIRECT_ASSIGNMENT_TAKE_APPEAL`,
);

export const directAssignmentTakeAppeal = makeApiActionCreatorV3(
  api.directAssignmentTakeAppeal,
  DIRECT_ASSIGNMENT_TAKE_APPEAL[START],
  DIRECT_ASSIGNMENT_TAKE_APPEAL[SUCCESS],
  DIRECT_ASSIGNMENT_TAKE_APPEAL[ERROR],
);

export const RETURN_TO_WAITING_ROOM = createRequestTypes(
  `${prefix}/RETURN_TO_WAITING_ROOM`,
);

export const returnToWaitingRoom = makeApiActionCreatorV3(
  api.returnToWaitingRoom,
  RETURN_TO_WAITING_ROOM[START],
  RETURN_TO_WAITING_ROOM[SUCCESS],
  RETURN_TO_WAITING_ROOM[ERROR],
);

export const SET_PANEL_VIEW_PANEL = `${prefix}/SET_PANEL_VIEW_PANEL`;

export const setPanelViewPanel = panel => ({
  type: SET_PANEL_VIEW_PANEL,
  payload: panel,
});

export const SET_PANEL_VIEW_PANEL_NEXT_APPEAL = `${prefix}/SET_PANEL_VIEW_PANEL_NEXT_APPEAL`;

export const setPanelViewPanelNextAppeal = nextAppealCase => ({
  type: SET_PANEL_VIEW_PANEL_NEXT_APPEAL,
  payload: nextAppealCase,
});

export const CLEAR_PANEL_VIEW_PANEL = `${prefix}/CLEAR_PANEL_VIEW_PANEL`;

export const clearPanelViewPanel = () => ({
  type: CLEAR_PANEL_VIEW_PANEL,
  payload: null,
});